/*
 * Icon set — Lucide (https://lucide.dev), one consistent library across the whole app.
 *
 * The rest of the codebase imports named `Icon*` components from this file, so mapping those
 * names to Lucide here swaps the entire app's iconography without touching a single call site.
 * Size is controlled by CSS (`.nav a svg`, the global `a svg`/`button svg` cap), so we only set
 * a consistent stroke weight and hide them from the accessibility tree (labels sit next to them).
 */
import {
  LayoutDashboard, Globe, KeyRound, Mail, LogOut, Check, AlertTriangle, Info,
  Server, Ban, Webhook, Activity, Users, Send, ShieldCheck, Inbox, FileText,
  Layers, GitBranch, HeartPulse, CreditCard, Settings as SettingsIcon, BarChart3,
  type LucideProps,
} from 'lucide-react'

const p: LucideProps = { strokeWidth: 1.75, 'aria-hidden': true }

// Brand mark stays custom — it is the logo, not a UI glyph.
export const IconMark = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden style={{ overflow: 'visible' }}>
    <rect x="2.2" y="4.6" width="16.6" height="12.4" rx="2.4" stroke="#fff" strokeWidth="2" />
    <path d="M3.2 6.6l7.3 5.2 7.3-5.2" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="18.6" cy="17.4" r="4.6" fill="#1de9b6" stroke="#0a0a0a" strokeWidth="1.4" />
    <path d="m16.6 17.5 1.4 1.4 2.6-2.8" stroke="#0a0a0a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export const IconOverview = () => <LayoutDashboard {...p} />
export const IconDomains = () => <Globe {...p} />
export const IconKeys = () => <KeyRound {...p} />
export const IconMessages = () => <Mail {...p} />
export const IconLogout = () => <LogOut {...p} />
export const IconCheck = () => <Check {...p} strokeWidth={2.4} />
export const IconAlert = () => <AlertTriangle {...p} />
export const IconInfo = () => <Info {...p} />
export const IconSmtp = () => <Server {...p} />
export const IconSuppress = () => <Ban {...p} />
export const IconWebhook = () => <Webhook {...p} />
export const IconActivity = () => <Activity {...p} />
export const IconTeam = () => <Users {...p} />
export const IconSend = () => <Send {...p} />
export const IconAdmin = () => <ShieldCheck {...p} />
export const IconInbound = () => <Inbox {...p} />

// New names used by the regrouped navigation.
export const IconTemplates = () => <FileText {...p} />
export const IconStreams = () => <Layers {...p} />
export const IconRoutes = () => <GitBranch {...p} />
export const IconHealth = () => <HeartPulse {...p} />
export const IconBilling = () => <CreditCard {...p} />
export const IconSettings = () => <SettingsIcon {...p} />
export const IconStats = () => <BarChart3 {...p} />
